import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var searchSuggestionsContainer = /*#__PURE__*/css(["position:absolute;left:0;right:0;margin-top:", ";height:var(--suggestionsHeight);background-color:var(--neutral-white-base);z-index:4;"], pxToRem(spacing.base));